// extracted by mini-css-extract-plugin
export default {"FeatureCard":"FeatureCard_FeatureCard__o7kC3","FeatureCard__heading":"FeatureCard_FeatureCard__heading__VwACA"};